import React from 'react';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import {
  TRAVEL_TIME_LIST,
  VEHICLE_REGISTRY_PRESENCE_LIST,
  VEHICLE_STATUS_LIST,
} from '../../../configs';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function VehicleFilterRow({
  toggleFilter, control, selectedTab, setValue = () => {}, getValues = () => {},
}) {
  const getDateValue = index => {
    const v = getValues('vehicle_datetime_at');
    if (v && v.length && v[index]) {
      return v[index];
    }
    return Date.now();
  };

  return (
    <FilterRow className="w-100">
      <FieldDTO
        control={control}
        component={TextSearchInput}
        dtoObject={{
          name: 'search',
          type: String,
          labelKey: 'search',
        }}
        className="no-border"
      />
      <FieldDTO
        control={control}
        component={CustomSelectInput}
        dtoObject={{
          name: 'has_registry_vehicle',
          type: String,
          labelKey: 'vehicle_registry_presence',
        }}
        className="no-border"
        addPlaceholder
        options={VEHICLE_REGISTRY_PRESENCE_LIST}
      />
      <FieldDTO
        control={control}
        component={CustomSelectInput}
        dtoObject={{
          name: 'vehicle_status',
          type: String,
          labelKey: 'status',
        }}
        usePortal
        className="no-border"
        options={VEHICLE_STATUS_LIST}
        placeholder="Статус"
        multiple
        addPlaceholder
      />

      <FieldDTO
        control={control}
        component={CustomSelectInput}
        dtoObject={{
          name: 'total_travel_time',
          type: String,
          labelKey: 'travel.time',
        }}
        usePortal
        className="no-border"
        options={TRAVEL_TIME_LIST}
        placeholder="Время в пути"
        addPlaceholder
      />
      {selectedTab === 1 ? (
        <FieldDTO
          control={control}
          component={RangeDatePicker}
          dtoObject={{
            name: 'created_at',
            type: String,
            labelKey: 'event.date',
          }}
          usePortal
          placeholder="Дата события"
          changeFormat="YYYY-MM-DD"
          className="no-border"
        />
      ) : null}
      {
        selectedTab === 3 ? (
          <>
            <FieldDTO
              control={control}
              component={DateTimePicker}
              dtoObject={{
                name: 'vehicle_datetime_at',
                type: String,
                labelKey: 'event.date',
              }}
              usePortal
              hideClose
              placeholder="Дата события с"
              changeFormat="YYYY-MM-DDTHH:mm:ss"
              className="no-border"
              inputProps={{
                onChange: e => { setValue('vehicle_datetime_at', [e.target.value || '', getDateValue(1)]); },
                value: getDateValue(0),
              }}
            />
            <FieldDTO
              control={control}
              component={DateTimePicker}
              dtoObject={{
                name: 'vehicle_datetime_at',
                type: String,
                labelKey: 'event.date',
              }}
              usePortal
              hideClose
              placeholder="Дата события по"
              changeFormat="YYYY-MM-DDTHH:mm:ss"
              className="no-border"
              inputProps={{
                onChange: e => { setValue('vehicle_datetime_at', [getDateValue(0), e.target.value || '']); },
                value: getDateValue(1),
              }}
            />
          </>
        ) : null
      }
      <div className="filter-sep" />
      <Button variant="second" onClick={toggleFilter}>
        <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
      </Button>
    </FilterRow>
  );
}
